import request from '@/utils/http'

// 创建枚举类型:
function createEnum (params: any) {
  return request({
    url: `education-enum/createEnum`,
    method: 'post',
    data: params
  })
}

// 创建枚举选项:
function createSelectOfEnum (params: any) {
  return request({
    url: `education-enum/createSelect`,
    method: 'post',
    data: params
  })
}

// 查询枚举类型:
function getEnumList () {
  return request({
    url: `education-enum/enumList`,
    method: 'get'
  })
}

// 查询枚举选项:
function enumSelectList (params: any) {
  return request({
    url: `education-enum/enumSelectList/${params.key}`,
    method: 'get'
  })
}

export default {
  createEnum,
  createSelectOfEnum,
  getEnumList,
  enumSelectList
}
